import styled from "styled-components";

import { breakpoints } from "../../../constants/breakpoints";

export const Wrap = styled.div`
  /* Mobile / default */
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  align-content: center;

  & > * {
    display: none;
  }

  & > :first-child {
    display: block;
  }
  /* Tablet breakpoint */
  @media only screen and (min-width: ${breakpoints.tablet}px) {
    align-items: flex-start;

    & > :first-child {
      width: 65%;
    }

    & > :nth-child(2) {
      display: block;
      width: 35%;
    }
    & > img {
      align-self: flex-start;
    }
  }

  /* Desktop breakpoint */
  @media only screen and (min-width: ${breakpoints.desktop}px) {
    & > :first-child,
    & > :nth-child(2) {
      width: 50%;
    }
  }
`;
